<!-- 
    @component
    # The Home component.
    This is the home page for the application. It doesn't really do much, but it's a good place to start.
 -->


<h1 class="header">Home</h1>
<p class="description">Welcome to Meandering Fellow! Use this website as your buddy in random exploration. Explore options in the menu above.</p>

<style>
    .header {
        font-size: 30px;
        padding: 12px;
    }

    .description {
        font-size: 16px;
        padding: 12px;
    }
</style>